import { debtsRequests } from "api/debtsApi";
import { resolveErrorMessage } from "utils/useNotifyError";

export const getDebtsWithTransactions = async ({ dataProvider, debtIds = [], notify }) => {
  try {
    if (!debtIds?.length) return [];

    const params = debtIds.map(id => `ids=${id}`).join("&");

    const debtsResponse = await dataProvider.customRequest(debtsRequests.getDebtsByIds(), null, "GET", `?${params}`);

    const debtsData = debtsResponse?.data || [];

    const debtsWithTransactions = await Promise.all(
      debtsData.map(async debt => {
        try {
          const { data: transactions } = await dataProvider.customRequest(debtsRequests.getDebtTransactions(debt.id));

          return {
            ...debt,
            transactions: transactions || [],
          };
        } catch (err) {
          notify?.(resolveErrorMessage(err), { type: "error" });

          return {
            ...debt,
            transactions: [],
          };
        }
      }),
    );

    return debtsWithTransactions;
  } catch (err) {
    notify?.(resolveErrorMessage(err), { type: "error" });

    return [];
  }
};
